export default {
  path: '/mp',
  title: '校园头条',
  icon: 'newspaper-o',
  hideSub: true,
  children: (pre => [
    {
      title: '账号矩阵',
      icon: 'weixin',
      path: `${pre}account`
    },
    {
      title: '文章管理',
      icon: 'newspaper-o',
      path: `${pre}news`
    },
    {
      title: '用户管理',
      icon: 'user',
      path: `${pre}user`
    },
    {
      title: '订单管理',
      icon: 'file',
      path: `${pre}order`
    }
    // {
    //   title: '签到管理',
    //   icon: 'pencil',
    //   path: `${pre}sign`
    // },
    // {
    //   title: '商品管理',
    //   icon: 'cube',
    //   path: `${pre}goods`
    // },
    // {
    //   title: '积分管理',
    //   icon: 'star',
    //   path: `${pre}credit`
    // }
  ])('/mp/')
}
